// If URL does not start with http:// or https://, add https://
export const addUrlProtocol = (url: string) => (url.match(/^https?:\/\//) ? url : `https://${url}`);

/**
 * Valid URLS:
 * http://www.google.com
 * https://www.google.com
 * www.google.com
 * google.com
 * @param url
 * @returns
 */
export const validateUrl = (url: string) => {
  const urlRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9]{2,})\.([a-zA-Z]{2,}|\su)(\/\S*)?$/;
  // This regex ensures the URL does not end with a dot
  const invalidEnd = /\.$/;

  //Accepted URL:
  //https://www.routal.com
  //routal.com
  //https://goo.su/ .... (Links acortados)
  //https://wa.me/5.... (Links de whatsapp)

  //Not Accepted URL:
  //https://www.routal.com.
  //http://www.exam ple.com
  //http://www.example.c&m
  //http://.com
  //w.com (domain shorter than 2 characters)
  //www.local

  return urlRegex.test(url) && !invalidEnd.test(url);
};
